module.exports = "/_next/static/videos/bg-section-main-9d35788fbc1aba8db74de981bc20bb9e.mp4";